const env = import.meta.env;

export const getEnvVar = (key: string): string | null => {
  const value = env[key];
  if (value === undefined) {
    console.warn(`Environment variable ${key} is not defined.`);
    return null;
  }
  return value;
};

export const getEnvVarAsBoolean = (key: string): boolean => {
  const value = getEnvVar(key);
  if (value === null || value.toLocaleLowerCase() === 'false') {
    return false;
  }
  return value.toLocaleLowerCase() === 'true';
};
